import { jsx as Re, jsxs as pa } from "react/jsx-runtime";
import { isPureObject as ha } from "../utils/misc/index.js";
import { E as ya, M as $a, D as Sa, R as Ca, B as wt, p as xa, b as _a } from "./button.js";
import { n as Pa } from "./emotion-styled.browser.esm.js";
import * as c from "react";
import wa, { createContext as Ea, useState as Q, useRef as te, useEffect as be, useMemo as Gt } from "react";
import { S as Ta } from "./dots-vertical.js";
import { d as H, P as Et, _ as se, i as Oa, q as nt, c as ae, n as G, h as Na, R as Tt, M as Ia, v as Ae, y as Ra, w as za, g as Wt, m as Vt, u, D as Kt, o as rt, A as it, B as tt, C as Ge, p as We } from "./CSSMotionList.js";
import { o as La } from "./omit.js";
import { d as ot } from "./warning.js";
import "./index.js";
import { u as Ot, a as Xt } from "./useSize.js";
import { S as Ma } from "./Skeleton.js";
import { R as Da } from "./CloseOutlined.js";
import { _ as pe } from "./extends.js";
import { I as Ba } from "./AntdIcon.js";
import { i as Ha } from "./roundedArrow.js";
import { R as et } from "./index5.js";
import { K as xe } from "./KeyCode.js";
import { t as ja, a as Aa } from "./ContextIsolator.js";
import { g as Ga } from "./zoom.js";
import { i as Nt } from "./Overflow.js";
import { u as Wa } from "./useVariants.js";
var Va = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { tag: "path", attrs: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, name: "plus", theme: "outlined" }, Ka = function(t, n) {
  return /* @__PURE__ */ c.createElement(Ba, pe({}, t, {
    ref: n,
    icon: Va
  }));
}, Ft = /* @__PURE__ */ c.forwardRef(Ka);
process.env.NODE_ENV !== "production" && (Ft.displayName = "PlusOutlined");
const Ve = /* @__PURE__ */ Ea(null);
var Xa = function(t) {
  var n = t.activeTabOffset, a = t.horizontal, r = t.rtl, i = t.indicator, l = i === void 0 ? {} : i, o = l.size, s = l.align, d = s === void 0 ? "center" : s, h = Q(), f = H(h, 2), y = f[0], w = f[1], R = te(), C = wa.useCallback(function(g) {
    return typeof o == "function" ? o(g) : typeof o == "number" ? o : g;
  }, [o]);
  function O() {
    Et.cancel(R.current);
  }
  return be(function() {
    var g = {};
    if (n)
      if (a) {
        g.width = C(n.width);
        var b = r ? "right" : "left";
        d === "start" && (g[b] = n[b]), d === "center" && (g[b] = n[b] + n.width / 2, g.transform = r ? "translateX(50%)" : "translateX(-50%)"), d === "end" && (g[b] = n[b] + n.width, g.transform = "translateX(-100%)");
      } else
        g.height = C(n.height), d === "start" && (g.top = n.top), d === "center" && (g.top = n.top + n.height / 2, g.transform = "translateY(-50%)"), d === "end" && (g.top = n.top + n.height, g.transform = "translateY(-100%)");
    return O(), R.current = Et(function() {
      var x = y && g && Object.keys(g).every(function(L) {
        var z = g[L], D = y[L];
        return typeof z == "number" && typeof D == "number" ? Math.round(z) === Math.round(D) : z === D;
      });
      x || w(g);
    }), O;
  }, [JSON.stringify(n), a, r, d, C]), {
    style: y
  };
}, It = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
function Fa(e, t, n) {
  return Gt(function() {
    for (var a, r = /* @__PURE__ */ new Map(), i = t.get((a = e[0]) === null || a === void 0 ? void 0 : a.key) || It, l = i.left + i.width, o = 0; o < e.length; o += 1) {
      var s = e[o].key, d = t.get(s);
      if (!d) {
        var h;
        d = t.get((h = e[o - 1]) === null || h === void 0 ? void 0 : h.key) || It;
      }
      var f = r.get(s) || se({}, d);
      f.right = l - f.left - f.width, r.set(s, f);
    }
    return r;
  }, [e.map(function(a) {
    return a.key;
  }).join("_"), t, n]);
}
function Rt(e, t) {
  var n = c.useRef(e), a = c.useState({}), r = H(a, 2), i = r[1];
  function l(o) {
    var s = typeof o == "function" ? o(n.current) : o;
    s !== n.current && t(s, n.current), n.current = s, i({});
  }
  return [n.current, l];
}
var Ua = 0.1, zt = 0.01, je = 20, Lt = Math.pow(0.995, je);
function qa(e, t) {
  var n = Q(), a = H(n, 2), r = a[0], i = a[1], l = Q(0), o = H(l, 2), s = o[0], d = o[1], h = Q(0), f = H(h, 2), y = f[0], w = f[1], R = Q(), C = H(R, 2), O = C[0], g = C[1], b = te();
  function x(S) {
    var I = S.touches[0], $ = I.screenX, _ = I.screenY;
    i({
      x: $,
      y: _
    }), window.clearInterval(b.current);
  }
  function L(S) {
    if (r) {
      var I = S.touches[0], $ = I.screenX, _ = I.screenY;
      i({
        x: $,
        y: _
      });
      var m = $ - r.x, P = _ - r.y;
      t(m, P);
      var U = Date.now();
      d(U), w(U - s), g({
        x: m,
        y: P
      });
    }
  }
  function z() {
    if (r && (i(null), g(null), O)) {
      var S = O.x / y, I = O.y / y, $ = Math.abs(S), _ = Math.abs(I);
      if (Math.max($, _) < Ua) return;
      var m = S, P = I;
      b.current = window.setInterval(function() {
        if (Math.abs(m) < zt && Math.abs(P) < zt) {
          window.clearInterval(b.current);
          return;
        }
        m *= Lt, P *= Lt, t(m * je, P * je);
      }, je);
    }
  }
  var D = te();
  function V(S) {
    var I = S.deltaX, $ = S.deltaY, _ = 0, m = Math.abs(I), P = Math.abs($);
    m === P ? _ = D.current === "x" ? I : $ : m > P ? (_ = I, D.current = "x") : (_ = $, D.current = "y"), t(-_, -_) && S.preventDefault();
  }
  var N = te(null);
  N.current = {
    onTouchStart: x,
    onTouchMove: L,
    onTouchEnd: z,
    onWheel: V
  }, c.useEffect(function() {
    function S(m) {
      N.current.onTouchStart(m);
    }
    function I(m) {
      N.current.onTouchMove(m);
    }
    function $(m) {
      N.current.onTouchEnd(m);
    }
    function _(m) {
      N.current.onWheel(m);
    }
    return document.addEventListener("touchmove", I, {
      passive: !1
    }), document.addEventListener("touchend", $, {
      passive: !0
    }), e.current.addEventListener("touchstart", S, {
      passive: !0
    }), e.current.addEventListener("wheel", _, {
      passive: !1
    }), function() {
      document.removeEventListener("touchmove", I), document.removeEventListener("touchend", $);
    };
  }, []);
}
function Ut(e) {
  var t = Q(0), n = H(t, 2), a = n[0], r = n[1], i = te(0), l = te();
  return l.current = e, Oa(function() {
    var o;
    (o = l.current) === null || o === void 0 || o.call(l);
  }, [a]), function() {
    i.current === a && (i.current += 1, r(i.current));
  };
}
function Ya(e) {
  var t = te([]), n = Q({}), a = H(n, 2), r = a[1], i = te(typeof e == "function" ? e() : e), l = Ut(function() {
    var s = i.current;
    t.current.forEach(function(d) {
      s = d(s);
    }), t.current = [], i.current = s, r({});
  });
  function o(s) {
    t.current.push(s), l();
  }
  return [i.current, o];
}
var Mt = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  right: 0
};
function Ja(e, t, n, a, r, i, l) {
  var o = l.tabs, s = l.tabPosition, d = l.rtl, h, f, y;
  return ["top", "bottom"].includes(s) ? (h = "width", f = d ? "right" : "left", y = Math.abs(n)) : (h = "height", f = "top", y = -n), Gt(function() {
    if (!o.length)
      return [0, 0];
    for (var w = o.length, R = w, C = 0; C < w; C += 1) {
      var O = e.get(o[C].key) || Mt;
      if (Math.floor(O[f] + O[h]) > Math.floor(y + t)) {
        R = C - 1;
        break;
      }
    }
    for (var g = 0, b = w - 1; b >= 0; b -= 1) {
      var x = e.get(o[b].key) || Mt;
      if (x[f] < y) {
        g = b + 1;
        break;
      }
    }
    return g >= R ? [0, 0] : [g, R];
  }, [e, t, a, r, i, y, s, o.map(function(w) {
    return w.key;
  }).join("_"), d]);
}
function Dt(e) {
  var t;
  return e instanceof Map ? (t = {}, e.forEach(function(n, a) {
    t[a] = n;
  })) : t = e, JSON.stringify(t);
}
var Qa = "TABS_DQ";
function qt(e) {
  return String(e).replace(/"/g, Qa);
}
function lt(e, t, n, a) {
  return (
    // Only editable tabs can be removed
    !(!n || // Tabs cannot be removed when disabled
    a || // closable is false
    e === !1 || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    e === void 0 && (t === !1 || t === null))
  );
}
var Yt = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.prefixCls, a = e.editable, r = e.locale, i = e.style;
  return !a || a.showAdd === !1 ? null : /* @__PURE__ */ c.createElement("button", {
    ref: t,
    type: "button",
    className: "".concat(n, "-nav-add"),
    style: i,
    "aria-label": (r == null ? void 0 : r.addAriaLabel) || "Add tab",
    onClick: function(o) {
      a.onEdit("add", {
        event: o
      });
    }
  }, a.addIcon || "+");
}), at = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.position, a = e.prefixCls, r = e.extra;
  if (!r)
    return null;
  var i, l = {};
  return nt(r) === "object" && !/* @__PURE__ */ c.isValidElement(r) ? l = r : l.right = r, n === "right" && (i = l.right), n === "left" && (i = l.left), i ? /* @__PURE__ */ c.createElement("div", {
    className: "".concat(a, "-extra-content"),
    ref: t
  }, i) : null;
});
process.env.NODE_ENV !== "production" && (at.displayName = "ExtraContent");
var Za = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.prefixCls, a = e.id, r = e.tabs, i = e.locale, l = e.mobile, o = e.more, s = o === void 0 ? {} : o, d = e.style, h = e.className, f = e.editable, y = e.tabBarGutter, w = e.rtl, R = e.removeAriaLabel, C = e.onTabClick, O = e.getPopupContainer, g = e.popupClassName, b = Q(!1), x = H(b, 2), L = x[0], z = x[1], D = Q(null), V = H(D, 2), N = V[0], S = V[1], I = s.icon, $ = I === void 0 ? "More" : I, _ = "".concat(a, "-more-popup"), m = "".concat(n, "-dropdown"), P = N !== null ? "".concat(_, "-").concat(N) : null, U = i == null ? void 0 : i.dropdownAriaLabel;
  function A(E, W) {
    E.preventDefault(), E.stopPropagation(), f.onEdit("remove", {
      key: W,
      event: E
    });
  }
  var K = /* @__PURE__ */ c.createElement(ya, {
    onClick: function(W) {
      var Y = W.key, J = W.domEvent;
      C(Y, J), z(!1);
    },
    prefixCls: "".concat(m, "-menu"),
    id: _,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": P,
    selectedKeys: [N],
    "aria-label": U !== void 0 ? U : "expanded dropdown"
  }, r.map(function(E) {
    var W = E.closable, Y = E.disabled, J = E.closeIcon, q = E.key, ie = E.label, ee = lt(W, J, f, Y);
    return /* @__PURE__ */ c.createElement($a, {
      key: q,
      id: "".concat(_, "-").concat(q),
      role: "option",
      "aria-controls": a && "".concat(a, "-panel-").concat(q),
      disabled: Y
    }, /* @__PURE__ */ c.createElement("span", null, ie), ee && /* @__PURE__ */ c.createElement("button", {
      type: "button",
      "aria-label": R || "remove",
      tabIndex: 0,
      className: "".concat(m, "-menu-item-remove"),
      onClick: function(ve) {
        ve.stopPropagation(), A(ve, q);
      }
    }, J || f.removeIcon || "×"));
  }));
  function k(E) {
    for (var W = r.filter(function(ee) {
      return !ee.disabled;
    }), Y = W.findIndex(function(ee) {
      return ee.key === N;
    }) || 0, J = W.length, q = 0; q < J; q += 1) {
      Y = (Y + E + J) % J;
      var ie = W[Y];
      if (!ie.disabled) {
        S(ie.key);
        return;
      }
    }
  }
  function v(E) {
    var W = E.which;
    if (!L) {
      [xe.DOWN, xe.SPACE, xe.ENTER].includes(W) && (z(!0), E.preventDefault());
      return;
    }
    switch (W) {
      case xe.UP:
        k(-1), E.preventDefault();
        break;
      case xe.DOWN:
        k(1), E.preventDefault();
        break;
      case xe.ESC:
        z(!1);
        break;
      case xe.SPACE:
      case xe.ENTER:
        N !== null && C(N, E);
        break;
    }
  }
  be(function() {
    var E = document.getElementById(P);
    E && E.scrollIntoView && E.scrollIntoView(!1);
  }, [N]), be(function() {
    L || S(null);
  }, [L]);
  var re = ae({}, w ? "marginRight" : "marginLeft", y);
  r.length || (re.visibility = "hidden", re.order = 1);
  var ne = G(ae({}, "".concat(m, "-rtl"), w)), Z = l ? null : /* @__PURE__ */ c.createElement(Sa, pe({
    prefixCls: m,
    overlay: K,
    visible: r.length ? L : !1,
    onVisibleChange: z,
    overlayClassName: G(ne, g),
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    getPopupContainer: O
  }, s), /* @__PURE__ */ c.createElement("button", {
    type: "button",
    className: "".concat(n, "-nav-more"),
    style: re,
    "aria-haspopup": "listbox",
    "aria-controls": _,
    id: "".concat(a, "-more"),
    "aria-expanded": L,
    onKeyDown: v
  }, $));
  return /* @__PURE__ */ c.createElement("div", {
    className: G("".concat(n, "-nav-operations"), h),
    style: d,
    ref: t
  }, Z, /* @__PURE__ */ c.createElement(Yt, {
    prefixCls: n,
    locale: i,
    editable: f
  }));
});
const ka = /* @__PURE__ */ c.memo(Za, function(e, t) {
  return (
    // https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    t.tabMoving
  );
});
var en = function(t) {
  var n = t.prefixCls, a = t.id, r = t.active, i = t.focus, l = t.tab, o = l.key, s = l.label, d = l.disabled, h = l.closeIcon, f = l.icon, y = t.closable, w = t.renderWrapper, R = t.removeAriaLabel, C = t.editable, O = t.onClick, g = t.onFocus, b = t.onBlur, x = t.onKeyDown, L = t.onMouseDown, z = t.onMouseUp, D = t.style, V = t.tabCount, N = t.currentPosition, S = "".concat(n, "-tab"), I = lt(y, h, C, d);
  function $(A) {
    d || O(A);
  }
  function _(A) {
    A.preventDefault(), A.stopPropagation(), C.onEdit("remove", {
      key: o,
      event: A
    });
  }
  var m = c.useMemo(function() {
    return f && typeof s == "string" ? /* @__PURE__ */ c.createElement("span", null, s) : s;
  }, [s, f]), P = c.useRef(null);
  c.useEffect(function() {
    i && P.current && P.current.focus();
  }, [i]);
  var U = /* @__PURE__ */ c.createElement("div", {
    key: o,
    "data-node-key": qt(o),
    className: G(S, ae(ae(ae(ae({}, "".concat(S, "-with-remove"), I), "".concat(S, "-active"), r), "".concat(S, "-disabled"), d), "".concat(S, "-focus"), i)),
    style: D,
    onClick: $
  }, /* @__PURE__ */ c.createElement("div", {
    ref: P,
    role: "tab",
    "aria-selected": r,
    id: a && "".concat(a, "-tab-").concat(o),
    className: "".concat(S, "-btn"),
    "aria-controls": a && "".concat(a, "-panel-").concat(o),
    "aria-disabled": d,
    tabIndex: d ? null : r ? 0 : -1,
    onClick: function(K) {
      K.stopPropagation(), $(K);
    },
    onKeyDown: x,
    onMouseDown: L,
    onMouseUp: z,
    onFocus: g,
    onBlur: b
  }, i && /* @__PURE__ */ c.createElement("div", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "Tab ".concat(N, " of ").concat(V)), f && /* @__PURE__ */ c.createElement("span", {
    className: "".concat(S, "-icon")
  }, f), s && m), I && /* @__PURE__ */ c.createElement("button", {
    type: "button",
    role: "tab",
    "aria-label": R || "remove",
    tabIndex: r ? 0 : -1,
    className: "".concat(S, "-remove"),
    onClick: function(K) {
      K.stopPropagation(), _(K);
    }
  }, h || C.removeIcon || "×"));
  return w ? w(U) : U;
}, tn = function(t, n) {
  var a = t.offsetWidth, r = t.offsetHeight, i = t.offsetTop, l = t.offsetLeft, o = t.getBoundingClientRect(), s = o.width, d = o.height, h = o.left, f = o.top;
  return Math.abs(s - a) < 1 ? [s, d, h - n.left, f - n.top] : [a, r, l, i];
}, Te = function(t) {
  var n = t.current || {}, a = n.offsetWidth, r = a === void 0 ? 0 : a, i = n.offsetHeight, l = i === void 0 ? 0 : i;
  if (t.current) {
    var o = t.current.getBoundingClientRect(), s = o.width, d = o.height;
    if (Math.abs(s - r) < 1)
      return [s, d];
  }
  return [r, l];
}, Be = function(t, n) {
  return t[n ? 0 : 1];
}, Bt = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.className, a = e.style, r = e.id, i = e.animated, l = e.activeKey, o = e.rtl, s = e.extra, d = e.editable, h = e.locale, f = e.tabPosition, y = e.tabBarGutter, w = e.children, R = e.onTabClick, C = e.onTabScroll, O = e.indicator, g = c.useContext(Ve), b = g.prefixCls, x = g.tabs, L = te(null), z = te(null), D = te(null), V = te(null), N = te(null), S = te(null), I = te(null), $ = f === "top" || f === "bottom", _ = Rt(0, function(M, p) {
    $ && C && C({
      direction: M > p ? "left" : "right"
    });
  }), m = H(_, 2), P = m[0], U = m[1], A = Rt(0, function(M, p) {
    !$ && C && C({
      direction: M > p ? "top" : "bottom"
    });
  }), K = H(A, 2), k = K[0], v = K[1], re = Q([0, 0]), ne = H(re, 2), Z = ne[0], E = ne[1], W = Q([0, 0]), Y = H(W, 2), J = Y[0], q = Y[1], ie = Q([0, 0]), ee = H(ie, 2), he = ee[0], ve = ee[1], ye = Q([0, 0]), $e = H(ye, 2), T = $e[0], oe = $e[1], me = Ya(/* @__PURE__ */ new Map()), ze = H(me, 2), Xe = ze[0], Fe = ze[1], X = Fa(x, Xe, J[0]), B = Be(Z, $), de = Be(J, $), Oe = Be(he, $), dt = Be(T, $), ut = Math.floor(B) < Math.floor(de + Oe), fe = ut ? B - dt : B - Oe, ea = "".concat(b, "-nav-operations-hidden"), Se = 0, _e = 0;
  $ && o ? (Se = 0, _e = Math.max(0, de - fe)) : (Se = Math.min(0, fe - de), _e = 0);
  function Ue(M) {
    return M < Se ? Se : M > _e ? _e : M;
  }
  var qe = te(null), ta = Q(), vt = H(ta, 2), Le = vt[0], ft = vt[1];
  function Ye() {
    ft(Date.now());
  }
  function Je() {
    qe.current && clearTimeout(qe.current);
  }
  qa(V, function(M, p) {
    function j(F, ue) {
      F(function(le) {
        var we = Ue(le + ue);
        return we;
      });
    }
    return ut ? ($ ? j(U, M) : j(v, p), Je(), Ye(), !0) : !1;
  }), be(function() {
    return Je(), Le && (qe.current = setTimeout(function() {
      ft(0);
    }, 100)), Je;
  }, [Le]);
  var aa = Ja(
    X,
    // Container
    fe,
    // Transform
    $ ? P : k,
    // Tabs
    de,
    // Add
    Oe,
    // Operation
    dt,
    se(se({}, e), {}, {
      tabs: x
    })
  ), bt = H(aa, 2), na = bt[0], ra = bt[1], mt = Na(function() {
    var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : l, p = X.get(M) || {
      width: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0
    };
    if ($) {
      var j = P;
      o ? p.right < P ? j = p.right : p.right + p.width > P + fe && (j = p.right + p.width - fe) : p.left < -P ? j = -p.left : p.left + p.width > -P + fe && (j = -(p.left + p.width - fe)), v(0), U(Ue(j));
    } else {
      var F = k;
      p.top < -k ? F = -p.top : p.top + p.height > -k + fe && (F = -(p.top + p.height - fe)), U(0), v(Ue(F));
    }
  }), ia = Q(), gt = H(ia, 2), Ce = gt[0], Ne = gt[1], oa = Q(!1), pt = H(oa, 2), la = pt[0], ht = pt[1], ge = x.filter(function(M) {
    return !M.disabled;
  }).map(function(M) {
    return M.key;
  }), Pe = function(p) {
    var j = ge.indexOf(Ce || l), F = ge.length, ue = (j + p + F) % F, le = ge[ue];
    Ne(le);
  }, ca = function(p) {
    var j = p.code, F = o && $, ue = ge[0], le = ge[ge.length - 1];
    switch (j) {
      case "ArrowLeft": {
        $ && Pe(F ? 1 : -1);
        break;
      }
      case "ArrowRight": {
        $ && Pe(F ? -1 : 1);
        break;
      }
      case "ArrowUp": {
        p.preventDefault(), $ || Pe(-1);
        break;
      }
      case "ArrowDown": {
        p.preventDefault(), $ || Pe(1);
        break;
      }
      case "Home": {
        p.preventDefault(), Ne(ue);
        break;
      }
      case "End": {
        p.preventDefault(), Ne(le);
        break;
      }
      case "Enter":
      case "Space": {
        p.preventDefault(), R(Ce ?? l, p);
        break;
      }
      case "Backspace":
      case "Delete": {
        var we = ge.indexOf(Ce), ce = x.find(function(Ee) {
          return Ee.key === Ce;
        }), ke = lt(ce == null ? void 0 : ce.closable, ce == null ? void 0 : ce.closeIcon, d, ce == null ? void 0 : ce.disabled);
        ke && (p.preventDefault(), p.stopPropagation(), d.onEdit("remove", {
          key: Ce,
          event: p
        }), we === ge.length - 1 ? Pe(-1) : Pe(1));
        break;
      }
    }
  }, Me = {};
  $ ? Me[o ? "marginRight" : "marginLeft"] = y : Me.marginTop = y;
  var yt = x.map(function(M, p) {
    var j = M.key;
    return /* @__PURE__ */ c.createElement(en, {
      id: r,
      prefixCls: b,
      key: j,
      tab: M,
      style: p === 0 ? void 0 : Me,
      closable: M.closable,
      editable: d,
      active: j === l,
      focus: j === Ce,
      renderWrapper: w,
      removeAriaLabel: h == null ? void 0 : h.removeAriaLabel,
      tabCount: ge.length,
      currentPosition: p + 1,
      onClick: function(ue) {
        R(j, ue);
      },
      onKeyDown: ca,
      onFocus: function() {
        la || Ne(j), mt(j), Ye(), V.current && (o || (V.current.scrollLeft = 0), V.current.scrollTop = 0);
      },
      onBlur: function() {
        Ne(void 0);
      },
      onMouseDown: function() {
        ht(!0);
      },
      onMouseUp: function() {
        ht(!1);
      }
    });
  }), $t = function() {
    return Fe(function() {
      var p, j = /* @__PURE__ */ new Map(), F = (p = N.current) === null || p === void 0 ? void 0 : p.getBoundingClientRect();
      return x.forEach(function(ue) {
        var le, we = ue.key, ce = (le = N.current) === null || le === void 0 ? void 0 : le.querySelector('[data-node-key="'.concat(qt(we), '"]'));
        if (ce) {
          var ke = tn(ce, F), Ee = H(ke, 4), fa = Ee[0], ba = Ee[1], ma = Ee[2], ga = Ee[3];
          j.set(we, {
            width: fa,
            height: ba,
            left: ma,
            top: ga
          });
        }
      }), j;
    });
  };
  be(function() {
    $t();
  }, [x.map(function(M) {
    return M.key;
  }).join("_")]);
  var De = Ut(function() {
    var M = Te(L), p = Te(z), j = Te(D);
    E([M[0] - p[0] - j[0], M[1] - p[1] - j[1]]);
    var F = Te(I);
    ve(F);
    var ue = Te(S);
    oe(ue);
    var le = Te(N);
    q([le[0] - F[0], le[1] - F[1]]), $t();
  }), sa = x.slice(0, na), da = x.slice(ra + 1), St = [].concat(Tt(sa), Tt(da)), Ct = X.get(l), ua = Xa({
    activeTabOffset: Ct,
    horizontal: $,
    indicator: O,
    rtl: o
  }), va = ua.style;
  be(function() {
    mt();
  }, [l, Se, _e, Dt(Ct), Dt(X), $]), be(function() {
    De();
  }, [o]);
  var xt = !!St.length, Ie = "".concat(b, "-nav-wrap"), Qe, Ze, _t, Pt;
  return $ ? o ? (Ze = P > 0, Qe = P !== _e) : (Qe = P < 0, Ze = P !== Se) : (_t = k < 0, Pt = k !== Se), /* @__PURE__ */ c.createElement(et, {
    onResize: De
  }, /* @__PURE__ */ c.createElement("div", {
    ref: Ia(t, L),
    role: "tablist",
    "aria-orientation": $ ? "horizontal" : "vertical",
    className: G("".concat(b, "-nav"), n),
    style: a,
    onKeyDown: function() {
      Ye();
    }
  }, /* @__PURE__ */ c.createElement(at, {
    ref: z,
    position: "left",
    extra: s,
    prefixCls: b
  }), /* @__PURE__ */ c.createElement(et, {
    onResize: De
  }, /* @__PURE__ */ c.createElement("div", {
    className: G(Ie, ae(ae(ae(ae({}, "".concat(Ie, "-ping-left"), Qe), "".concat(Ie, "-ping-right"), Ze), "".concat(Ie, "-ping-top"), _t), "".concat(Ie, "-ping-bottom"), Pt)),
    ref: V
  }, /* @__PURE__ */ c.createElement(et, {
    onResize: De
  }, /* @__PURE__ */ c.createElement("div", {
    ref: N,
    className: "".concat(b, "-nav-list"),
    style: {
      transform: "translate(".concat(P, "px, ").concat(k, "px)"),
      transition: Le ? "none" : void 0
    }
  }, yt, /* @__PURE__ */ c.createElement(Yt, {
    ref: I,
    prefixCls: b,
    locale: h,
    editable: d,
    style: se(se({}, yt.length === 0 ? void 0 : Me), {}, {
      visibility: xt ? "hidden" : null
    })
  }), /* @__PURE__ */ c.createElement("div", {
    className: G("".concat(b, "-ink-bar"), ae({}, "".concat(b, "-ink-bar-animated"), i.inkBar)),
    style: va
  }))))), /* @__PURE__ */ c.createElement(ka, pe({}, e, {
    removeAriaLabel: h == null ? void 0 : h.removeAriaLabel,
    ref: S,
    prefixCls: b,
    tabs: St,
    className: !xt && ea,
    tabMoving: !!Le
  })), /* @__PURE__ */ c.createElement(at, {
    ref: D,
    position: "right",
    extra: s,
    prefixCls: b
  })));
}), ct = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.prefixCls, a = e.className, r = e.style, i = e.id, l = e.active, o = e.tabKey, s = e.children;
  return /* @__PURE__ */ c.createElement("div", {
    id: i && "".concat(i, "-panel-").concat(o),
    role: "tabpanel",
    tabIndex: l ? 0 : -1,
    "aria-labelledby": i && "".concat(i, "-tab-").concat(o),
    "aria-hidden": !l,
    style: r,
    className: G(n, l && "".concat(n, "-active"), a),
    ref: t
  }, s);
});
process.env.NODE_ENV !== "production" && (ct.displayName = "TabPane");
var an = ["renderTabBar"], nn = ["label", "key"], Jt = function(t) {
  var n = t.renderTabBar, a = Ae(t, an), r = c.useContext(Ve), i = r.tabs;
  if (n) {
    var l = se(se({}, a), {}, {
      // Legacy support. We do not use this actually
      panes: i.map(function(o) {
        var s = o.label, d = o.key, h = Ae(o, nn);
        return /* @__PURE__ */ c.createElement(ct, pe({
          tab: s,
          key: d,
          tabKey: d
        }, h));
      })
    });
    return n(l, Bt);
  }
  return /* @__PURE__ */ c.createElement(Bt, a);
};
process.env.NODE_ENV !== "production" && (Jt.displayName = "TabNavListWrapper");
var rn = ["key", "forceRender", "style", "className", "destroyInactiveTabPane"], on = function(t) {
  var n = t.id, a = t.activeKey, r = t.animated, i = t.tabPosition, l = t.destroyInactiveTabPane, o = c.useContext(Ve), s = o.prefixCls, d = o.tabs, h = r.tabPane, f = "".concat(s, "-tabpane");
  return /* @__PURE__ */ c.createElement("div", {
    className: G("".concat(s, "-content-holder"))
  }, /* @__PURE__ */ c.createElement("div", {
    className: G("".concat(s, "-content"), "".concat(s, "-content-").concat(i), ae({}, "".concat(s, "-content-animated"), h))
  }, d.map(function(y) {
    var w = y.key, R = y.forceRender, C = y.style, O = y.className, g = y.destroyInactiveTabPane, b = Ae(y, rn), x = w === a;
    return /* @__PURE__ */ c.createElement(Ra, pe({
      key: w,
      visible: x,
      forceRender: R,
      removeOnLeave: !!(l || g),
      leavedClassName: "".concat(f, "-hidden")
    }, r.tabPaneMotion), function(L, z) {
      var D = L.style, V = L.className;
      return /* @__PURE__ */ c.createElement(ct, pe({}, b, {
        prefixCls: f,
        id: n,
        tabKey: w,
        animated: h,
        active: x,
        style: se(se({}, C), D),
        className: G(O, V),
        ref: z
      }));
    });
  })));
};
function ln() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    inkBar: !0,
    tabPane: !1
  }, t;
  return e === !1 ? t = {
    inkBar: !1,
    tabPane: !1
  } : e === !0 ? t = {
    inkBar: !0,
    tabPane: !1
  } : t = se({
    inkBar: !0
  }, nt(e) === "object" ? e : {}), t.tabPaneMotion && t.tabPane === void 0 && (t.tabPane = !0), !t.tabPaneMotion && t.tabPane && (process.env.NODE_ENV !== "production" && za(!1, "`animated.tabPane` is true but `animated.tabPaneMotion` is not provided. Motion will not work."), t.tabPane = !1), t;
}
var cn = ["id", "prefixCls", "className", "items", "direction", "activeKey", "defaultActiveKey", "editable", "animated", "tabPosition", "tabBarGutter", "tabBarStyle", "tabBarExtraContent", "locale", "more", "destroyInactiveTabPane", "renderTabBar", "onChange", "onTabClick", "onTabScroll", "getPopupContainer", "popupClassName", "indicator"], Ht = 0, Qt = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.id, a = e.prefixCls, r = a === void 0 ? "rc-tabs" : a, i = e.className, l = e.items, o = e.direction, s = e.activeKey, d = e.defaultActiveKey, h = e.editable, f = e.animated, y = e.tabPosition, w = y === void 0 ? "top" : y, R = e.tabBarGutter, C = e.tabBarStyle, O = e.tabBarExtraContent, g = e.locale, b = e.more, x = e.destroyInactiveTabPane, L = e.renderTabBar, z = e.onChange, D = e.onTabClick, V = e.onTabScroll, N = e.getPopupContainer, S = e.popupClassName, I = e.indicator, $ = Ae(e, cn), _ = c.useMemo(function() {
    return (l || []).filter(function(T) {
      return T && nt(T) === "object" && "key" in T;
    });
  }, [l]), m = o === "rtl", P = ln(f), U = Q(!1), A = H(U, 2), K = A[0], k = A[1];
  be(function() {
    k(Ha());
  }, []);
  var v = Ot(function() {
    var T;
    return (T = _[0]) === null || T === void 0 ? void 0 : T.key;
  }, {
    value: s,
    defaultValue: d
  }), re = H(v, 2), ne = re[0], Z = re[1], E = Q(function() {
    return _.findIndex(function(T) {
      return T.key === ne;
    });
  }), W = H(E, 2), Y = W[0], J = W[1];
  be(function() {
    var T = _.findIndex(function(me) {
      return me.key === ne;
    });
    if (T === -1) {
      var oe;
      T = Math.max(0, Math.min(Y, _.length - 1)), Z((oe = _[T]) === null || oe === void 0 ? void 0 : oe.key);
    }
    J(T);
  }, [_.map(function(T) {
    return T.key;
  }).join("_"), ne, Y]);
  var q = Ot(null, {
    value: n
  }), ie = H(q, 2), ee = ie[0], he = ie[1];
  be(function() {
    n || (he("rc-tabs-".concat(process.env.NODE_ENV === "test" ? "test" : Ht)), Ht += 1);
  }, []);
  function ve(T, oe) {
    D == null || D(T, oe);
    var me = T !== ne;
    Z(T), me && (z == null || z(T));
  }
  var ye = {
    id: ee,
    activeKey: ne,
    animated: P,
    tabPosition: w,
    rtl: m,
    mobile: K
  }, $e = se(se({}, ye), {}, {
    editable: h,
    locale: g,
    more: b,
    tabBarGutter: R,
    onTabClick: ve,
    onTabScroll: V,
    extra: O,
    style: C,
    panes: null,
    getPopupContainer: N,
    popupClassName: S,
    indicator: I
  });
  return /* @__PURE__ */ c.createElement(Ve.Provider, {
    value: {
      tabs: _,
      prefixCls: r
    }
  }, /* @__PURE__ */ c.createElement("div", pe({
    ref: t,
    id: n,
    className: G(r, "".concat(r, "-").concat(w), ae(ae(ae({}, "".concat(r, "-mobile"), K), "".concat(r, "-editable"), h), "".concat(r, "-rtl"), m), i)
  }, $), /* @__PURE__ */ c.createElement(Jt, pe({}, $e, {
    renderTabBar: L
  })), /* @__PURE__ */ c.createElement(on, pe({
    destroyInactiveTabPane: x
  }, ye, {
    animated: P
  }))));
});
process.env.NODE_ENV !== "production" && (Qt.displayName = "Tabs");
const sn = {
  motionAppear: !1,
  motionEnter: !0,
  motionLeave: !0
};
function dn(e, t = {
  inkBar: !0,
  tabPane: !1
}) {
  let n;
  return t === !1 ? n = {
    inkBar: !1,
    tabPane: !1
  } : t === !0 ? n = {
    inkBar: !0,
    tabPane: !0
  } : n = Object.assign({
    inkBar: !0
  }, typeof t == "object" ? t : {}), n.tabPane && (n.tabPaneMotion = Object.assign(Object.assign({}, sn), {
    motionName: Ga(e, "switch")
  })), n;
}
var un = function(e, t) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, a = Object.getOwnPropertySymbols(e); r < a.length; r++)
    t.indexOf(a[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[r]) && (n[a[r]] = e[a[r]]);
  return n;
};
function vn(e) {
  return e.filter((t) => t);
}
function fn(e, t) {
  if (process.env.NODE_ENV !== "production" && ot("Tabs").deprecated(!t, "Tabs.TabPane", "items"), e)
    return e.map((a) => {
      var r;
      const i = (r = a.destroyOnHidden) !== null && r !== void 0 ? r : a.destroyInactiveTabPane;
      return Object.assign(Object.assign({}, a), {
        // TODO: In the future, destroyInactiveTabPane in rc-tabs needs to be upgrade to destroyOnHidden
        destroyInactiveTabPane: i
      });
    });
  const n = ja(t).map((a) => {
    if (/* @__PURE__ */ c.isValidElement(a)) {
      const {
        key: r,
        props: i
      } = a, l = i || {}, {
        tab: o
      } = l, s = un(l, ["tab"]);
      return Object.assign(Object.assign({
        key: String(r)
      }, s), {
        label: o
      });
    }
    return null;
  });
  return vn(n);
}
const bn = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n
  } = e;
  return [
    {
      [t]: {
        [`${t}-switch`]: {
          "&-appear, &-enter": {
            transition: "none",
            "&-start": {
              opacity: 0
            },
            "&-active": {
              opacity: 1,
              transition: `opacity ${n}`
            }
          },
          "&-leave": {
            position: "absolute",
            transition: "none",
            inset: 0,
            "&-start": {
              opacity: 1
            },
            "&-active": {
              opacity: 0,
              transition: `opacity ${n}`
            }
          }
        }
      }
    },
    // Follow code may reuse in other components
    [Nt(e, "slide-up"), Nt(e, "slide-down")]
  ];
}, mn = (e) => {
  const {
    componentCls: t,
    tabsCardPadding: n,
    cardBg: a,
    cardGutter: r,
    colorBorderSecondary: i,
    itemSelectedColor: l
  } = e;
  return {
    [`${t}-card`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-tab`]: {
          margin: 0,
          padding: n,
          background: a,
          border: `${u(e.lineWidth)} ${e.lineType} ${i}`,
          transition: `all ${e.motionDurationSlow} ${e.motionEaseInOut}`
        },
        [`${t}-tab-active`]: {
          color: l,
          background: e.colorBgContainer
        },
        [`${t}-tab-focus:has(${t}-tab-btn:focus-visible)`]: Kt(e, -3),
        [`& ${t}-tab${t}-tab-focus ${t}-tab-btn:focus-visible`]: {
          outline: "none"
        },
        [`${t}-ink-bar`]: {
          visibility: "hidden"
        }
      },
      // ========================== Top & Bottom ==========================
      [`&${t}-top, &${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginLeft: {
              _skip_check_: !0,
              value: u(r)
            }
          }
        }
      },
      [`&${t}-top`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: `${u(e.borderRadiusLG)} ${u(e.borderRadiusLG)} 0 0`
          },
          [`${t}-tab-active`]: {
            borderBottomColor: e.colorBgContainer
          }
        }
      },
      [`&${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: `0 0 ${u(e.borderRadiusLG)} ${u(e.borderRadiusLG)}`
          },
          [`${t}-tab-active`]: {
            borderTopColor: e.colorBgContainer
          }
        }
      },
      // ========================== Left & Right ==========================
      [`&${t}-left, &${t}-right`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginTop: u(r)
          }
        }
      },
      [`&${t}-left`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${u(e.borderRadiusLG)} 0 0 ${u(e.borderRadiusLG)}`
            }
          },
          [`${t}-tab-active`]: {
            borderRightColor: {
              _skip_check_: !0,
              value: e.colorBgContainer
            }
          }
        }
      },
      [`&${t}-right`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${u(e.borderRadiusLG)} ${u(e.borderRadiusLG)} 0`
            }
          },
          [`${t}-tab-active`]: {
            borderLeftColor: {
              _skip_check_: !0,
              value: e.colorBgContainer
            }
          }
        }
      }
    }
  };
}, gn = (e) => {
  const {
    componentCls: t,
    itemHoverColor: n,
    dropdownEdgeChildVerticalPadding: a
  } = e;
  return {
    [`${t}-dropdown`]: Object.assign(Object.assign({}, rt(e)), {
      position: "absolute",
      top: -9999,
      left: {
        _skip_check_: !0,
        value: -9999
      },
      zIndex: e.zIndexPopup,
      display: "block",
      "&-hidden": {
        display: "none"
      },
      [`${t}-dropdown-menu`]: {
        maxHeight: e.tabsDropdownHeight,
        margin: 0,
        padding: `${u(a)} 0`,
        overflowX: "hidden",
        overflowY: "auto",
        textAlign: {
          _skip_check_: !0,
          value: "left"
        },
        listStyleType: "none",
        backgroundColor: e.colorBgContainer,
        backgroundClip: "padding-box",
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        "&-item": Object.assign(Object.assign({}, it), {
          display: "flex",
          alignItems: "center",
          minWidth: e.tabsDropdownWidth,
          margin: 0,
          padding: `${u(e.paddingXXS)} ${u(e.paddingSM)}`,
          color: e.colorText,
          fontWeight: "normal",
          fontSize: e.fontSize,
          lineHeight: e.lineHeight,
          cursor: "pointer",
          transition: `all ${e.motionDurationSlow}`,
          "> span": {
            flex: 1,
            whiteSpace: "nowrap"
          },
          "&-remove": {
            flex: "none",
            marginLeft: {
              _skip_check_: !0,
              value: e.marginSM
            },
            color: e.colorIcon,
            fontSize: e.fontSizeSM,
            background: "transparent",
            border: 0,
            cursor: "pointer",
            "&:hover": {
              color: n
            }
          },
          "&:hover": {
            background: e.controlItemBgHover
          },
          "&-disabled": {
            "&, &:hover": {
              color: e.colorTextDisabled,
              background: "transparent",
              cursor: "not-allowed"
            }
          }
        })
      }
    })
  };
}, pn = (e) => {
  const {
    componentCls: t,
    margin: n,
    colorBorderSecondary: a,
    horizontalMargin: r,
    verticalItemPadding: i,
    verticalItemMargin: l,
    calc: o
  } = e;
  return {
    // ========================== Top & Bottom ==========================
    [`${t}-top, ${t}-bottom`]: {
      flexDirection: "column",
      [`> ${t}-nav, > div > ${t}-nav`]: {
        margin: r,
        "&::before": {
          position: "absolute",
          right: {
            _skip_check_: !0,
            value: 0
          },
          left: {
            _skip_check_: !0,
            value: 0
          },
          borderBottom: `${u(e.lineWidth)} ${e.lineType} ${a}`,
          content: "''"
        },
        [`${t}-ink-bar`]: {
          height: e.lineWidthBold,
          "&-animated": {
            transition: `width ${e.motionDurationSlow}, left ${e.motionDurationSlow},
            right ${e.motionDurationSlow}`
          }
        },
        [`${t}-nav-wrap`]: {
          "&::before, &::after": {
            top: 0,
            bottom: 0,
            width: e.controlHeight
          },
          "&::before": {
            left: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: e.boxShadowTabsOverflowLeft
          },
          "&::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: e.boxShadowTabsOverflowRight
          },
          [`&${t}-nav-wrap-ping-left::before`]: {
            opacity: 1
          },
          [`&${t}-nav-wrap-ping-right::after`]: {
            opacity: 1
          }
        }
      }
    },
    [`${t}-top`]: {
      [`> ${t}-nav,
        > div > ${t}-nav`]: {
        "&::before": {
          bottom: 0
        },
        [`${t}-ink-bar`]: {
          bottom: 0
        }
      }
    },
    [`${t}-bottom`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        order: 1,
        marginTop: n,
        marginBottom: 0,
        "&::before": {
          top: 0
        },
        [`${t}-ink-bar`]: {
          top: 0
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        order: 0
      }
    },
    // ========================== Left & Right ==========================
    [`${t}-left, ${t}-right`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        flexDirection: "column",
        minWidth: o(e.controlHeight).mul(1.25).equal(),
        // >>>>>>>>>>> Tab
        [`${t}-tab`]: {
          padding: i,
          textAlign: "center"
        },
        [`${t}-tab + ${t}-tab`]: {
          margin: l
        },
        // >>>>>>>>>>> Nav
        [`${t}-nav-wrap`]: {
          flexDirection: "column",
          "&::before, &::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: e.controlHeight
          },
          "&::before": {
            top: 0,
            boxShadow: e.boxShadowTabsOverflowTop
          },
          "&::after": {
            bottom: 0,
            boxShadow: e.boxShadowTabsOverflowBottom
          },
          [`&${t}-nav-wrap-ping-top::before`]: {
            opacity: 1
          },
          [`&${t}-nav-wrap-ping-bottom::after`]: {
            opacity: 1
          }
        },
        // >>>>>>>>>>> Ink Bar
        [`${t}-ink-bar`]: {
          width: e.lineWidthBold,
          "&-animated": {
            transition: `height ${e.motionDurationSlow}, top ${e.motionDurationSlow}`
          }
        },
        [`${t}-nav-list, ${t}-nav-operations`]: {
          flex: "1 0 auto",
          // fix safari scroll problem
          flexDirection: "column"
        }
      }
    },
    [`${t}-left`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-ink-bar`]: {
          right: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        marginLeft: {
          _skip_check_: !0,
          value: u(o(e.lineWidth).mul(-1).equal())
        },
        borderLeft: {
          _skip_check_: !0,
          value: `${u(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        [`> ${t}-content > ${t}-tabpane`]: {
          paddingLeft: {
            _skip_check_: !0,
            value: e.paddingLG
          }
        }
      }
    },
    [`${t}-right`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        order: 1,
        [`${t}-ink-bar`]: {
          left: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        order: 0,
        marginRight: {
          _skip_check_: !0,
          value: o(e.lineWidth).mul(-1).equal()
        },
        borderRight: {
          _skip_check_: !0,
          value: `${u(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        [`> ${t}-content > ${t}-tabpane`]: {
          paddingRight: {
            _skip_check_: !0,
            value: e.paddingLG
          }
        }
      }
    }
  };
}, hn = (e) => {
  const {
    componentCls: t,
    cardPaddingSM: n,
    cardPaddingLG: a,
    cardHeightSM: r,
    cardHeightLG: i,
    horizontalItemPaddingSM: l,
    horizontalItemPaddingLG: o
  } = e;
  return {
    // >>>>> shared
    [t]: {
      "&-small": {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: l,
            fontSize: e.titleFontSizeSM
          }
        }
      },
      "&-large": {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: o,
            fontSize: e.titleFontSizeLG,
            lineHeight: e.lineHeightLG
          }
        }
      }
    },
    // >>>>> card
    [`${t}-card`]: {
      // Small
      [`&${t}-small`]: {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: n
          },
          [`${t}-nav-add`]: {
            minWidth: r,
            minHeight: r
          }
        },
        [`&${t}-bottom`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: `0 0 ${u(e.borderRadius)} ${u(e.borderRadius)}`
          }
        },
        [`&${t}-top`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: `${u(e.borderRadius)} ${u(e.borderRadius)} 0 0`
          }
        },
        [`&${t}-right`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${u(e.borderRadius)} ${u(e.borderRadius)} 0`
            }
          }
        },
        [`&${t}-left`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${u(e.borderRadius)} 0 0 ${u(e.borderRadius)}`
            }
          }
        }
      },
      // Large
      [`&${t}-large`]: {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: a
          },
          [`${t}-nav-add`]: {
            minWidth: i,
            minHeight: i
          }
        }
      }
    }
  };
}, yn = (e) => {
  const {
    componentCls: t,
    itemActiveColor: n,
    itemHoverColor: a,
    iconCls: r,
    tabsHorizontalItemMargin: i,
    horizontalItemPadding: l,
    itemSelectedColor: o,
    itemColor: s
  } = e, d = `${t}-tab`;
  return {
    [d]: {
      position: "relative",
      WebkitTouchCallout: "none",
      WebkitTapHighlightColor: "transparent",
      display: "inline-flex",
      alignItems: "center",
      padding: l,
      fontSize: e.titleFontSize,
      background: "transparent",
      border: 0,
      outline: "none",
      cursor: "pointer",
      color: s,
      "&-btn, &-remove": {
        "&:focus:not(:focus-visible), &:active": {
          color: n
        }
      },
      "&-btn": {
        outline: "none",
        transition: `all ${e.motionDurationSlow}`,
        [`${d}-icon:not(:last-child)`]: {
          marginInlineEnd: e.marginSM
        }
      },
      "&-remove": Object.assign({
        flex: "none",
        marginRight: {
          _skip_check_: !0,
          value: e.calc(e.marginXXS).mul(-1).equal()
        },
        marginLeft: {
          _skip_check_: !0,
          value: e.marginXS
        },
        color: e.colorIcon,
        fontSize: e.fontSizeSM,
        background: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        transition: `all ${e.motionDurationSlow}`,
        "&:hover": {
          color: e.colorTextHeading
        }
      }, tt(e)),
      "&:hover": {
        color: a
      },
      [`&${d}-active ${d}-btn`]: {
        color: o,
        textShadow: e.tabsActiveTextShadow
      },
      [`&${d}-focus ${d}-btn:focus-visible`]: Kt(e),
      [`&${d}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed"
      },
      [`&${d}-disabled ${d}-btn, &${d}-disabled ${t}-remove`]: {
        "&:focus, &:active": {
          color: e.colorTextDisabled
        }
      },
      [`& ${d}-remove ${r}`]: {
        margin: 0
      },
      [`${r}:not(:last-child)`]: {
        marginRight: {
          _skip_check_: !0,
          value: e.marginSM
        }
      }
    },
    [`${d} + ${d}`]: {
      margin: {
        _skip_check_: !0,
        value: i
      }
    }
  };
}, $n = (e) => {
  const {
    componentCls: t,
    tabsHorizontalItemMarginRTL: n,
    iconCls: a,
    cardGutter: r,
    calc: i
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl",
      [`${t}-nav`]: {
        [`${t}-tab`]: {
          margin: {
            _skip_check_: !0,
            value: n
          },
          [`${t}-tab:last-of-type`]: {
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          },
          [a]: {
            marginRight: {
              _skip_check_: !0,
              value: 0
            },
            marginLeft: {
              _skip_check_: !0,
              value: u(e.marginSM)
            }
          },
          [`${t}-tab-remove`]: {
            marginRight: {
              _skip_check_: !0,
              value: u(e.marginXS)
            },
            marginLeft: {
              _skip_check_: !0,
              value: u(i(e.marginXXS).mul(-1).equal())
            },
            [a]: {
              margin: 0
            }
          }
        }
      },
      [`&${t}-left`]: {
        [`> ${t}-nav`]: {
          order: 1
        },
        [`> ${t}-content-holder`]: {
          order: 0
        }
      },
      [`&${t}-right`]: {
        [`> ${t}-nav`]: {
          order: 0
        },
        [`> ${t}-content-holder`]: {
          order: 1
        }
      },
      // ====================== Card ======================
      [`&${t}-card${t}-top, &${t}-card${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginRight: {
              _skip_check_: !0,
              value: r
            },
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          }
        }
      }
    },
    [`${t}-dropdown-rtl`]: {
      direction: "rtl"
    },
    [`${t}-menu-item`]: {
      [`${t}-dropdown-rtl`]: {
        textAlign: {
          _skip_check_: !0,
          value: "right"
        }
      }
    }
  };
}, Sn = (e) => {
  const {
    componentCls: t,
    tabsCardPadding: n,
    cardHeight: a,
    cardGutter: r,
    itemHoverColor: i,
    itemActiveColor: l,
    colorBorderSecondary: o
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, rt(e)), {
      display: "flex",
      // ========================== Navigation ==========================
      [`> ${t}-nav, > div > ${t}-nav`]: {
        position: "relative",
        display: "flex",
        flex: "none",
        alignItems: "center",
        [`${t}-nav-wrap`]: {
          position: "relative",
          display: "flex",
          flex: "auto",
          alignSelf: "stretch",
          overflow: "hidden",
          whiteSpace: "nowrap",
          transform: "translate(0)",
          // Fix chrome render bug
          // >>>>> Ping shadow
          "&::before, &::after": {
            position: "absolute",
            zIndex: 1,
            opacity: 0,
            transition: `opacity ${e.motionDurationSlow}`,
            content: "''",
            pointerEvents: "none"
          }
        },
        [`${t}-nav-list`]: {
          position: "relative",
          display: "flex",
          transition: `opacity ${e.motionDurationSlow}`
        },
        // >>>>>>>> Operations
        [`${t}-nav-operations`]: {
          display: "flex",
          alignSelf: "stretch"
        },
        [`${t}-nav-operations-hidden`]: {
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none"
        },
        [`${t}-nav-more`]: {
          position: "relative",
          padding: n,
          background: "transparent",
          border: 0,
          color: e.colorText,
          "&::after": {
            position: "absolute",
            right: {
              _skip_check_: !0,
              value: 0
            },
            bottom: 0,
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: e.calc(e.controlHeightLG).div(8).equal(),
            transform: "translateY(100%)",
            content: "''"
          }
        },
        [`${t}-nav-add`]: Object.assign({
          minWidth: a,
          minHeight: a,
          marginLeft: {
            _skip_check_: !0,
            value: r
          },
          background: "transparent",
          border: `${u(e.lineWidth)} ${e.lineType} ${o}`,
          borderRadius: `${u(e.borderRadiusLG)} ${u(e.borderRadiusLG)} 0 0`,
          outline: "none",
          cursor: "pointer",
          color: e.colorText,
          transition: `all ${e.motionDurationSlow} ${e.motionEaseInOut}`,
          "&:hover": {
            color: i
          },
          "&:active, &:focus:not(:focus-visible)": {
            color: l
          }
        }, tt(e, -3))
      },
      [`${t}-extra-content`]: {
        flex: "none"
      },
      // ============================ InkBar ============================
      [`${t}-ink-bar`]: {
        position: "absolute",
        background: e.inkBarColor,
        pointerEvents: "none"
      }
    }), yn(e)), {
      // =========================== TabPanes ===========================
      [`${t}-content`]: {
        position: "relative",
        width: "100%"
      },
      [`${t}-content-holder`]: {
        flex: "auto",
        minWidth: 0,
        minHeight: 0
      },
      [`${t}-tabpane`]: Object.assign(Object.assign({}, tt(e)), {
        "&-hidden": {
          display: "none"
        }
      })
    }),
    [`${t}-centered`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-nav-wrap`]: {
          [`&:not([class*='${t}-nav-wrap-ping']) > ${t}-nav-list`]: {
            margin: "auto"
          }
        }
      }
    }
  };
}, Cn = (e) => {
  const {
    cardHeight: t,
    cardHeightSM: n,
    cardHeightLG: a,
    controlHeight: r,
    controlHeightLG: i
  } = e, l = t || i, o = n || r, s = a || i + 8;
  return {
    zIndexPopup: e.zIndexPopupBase + 50,
    cardBg: e.colorFillAlter,
    // We can not pass this as valid value,
    // Since `cardHeight` will lock nav add button height.
    cardHeight: l,
    cardHeightSM: o,
    cardHeightLG: s,
    // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
    cardPadding: `${(l - e.fontHeight) / 2 - e.lineWidth}px ${e.padding}px`,
    cardPaddingSM: `${(o - e.fontHeight) / 2 - e.lineWidth}px ${e.paddingXS}px`,
    cardPaddingLG: `${(s - e.fontHeightLG) / 2 - e.lineWidth}px ${e.padding}px`,
    titleFontSize: e.fontSize,
    titleFontSizeLG: e.fontSizeLG,
    titleFontSizeSM: e.fontSize,
    inkBarColor: e.colorPrimary,
    horizontalMargin: `0 0 ${e.margin}px 0`,
    horizontalItemGutter: 32,
    // Fixed Value
    // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
    horizontalItemMargin: "",
    horizontalItemMarginRTL: "",
    horizontalItemPadding: `${e.paddingSM}px 0`,
    horizontalItemPaddingSM: `${e.paddingXS}px 0`,
    horizontalItemPaddingLG: `${e.padding}px 0`,
    verticalItemPadding: `${e.paddingXS}px ${e.paddingLG}px`,
    verticalItemMargin: `${e.margin}px 0 0 0`,
    itemColor: e.colorText,
    itemSelectedColor: e.colorPrimary,
    itemHoverColor: e.colorPrimaryHover,
    itemActiveColor: e.colorPrimaryActive,
    cardGutter: e.marginXXS / 2
  };
}, xn = Wt("Tabs", (e) => {
  const t = Vt(e, {
    // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
    tabsCardPadding: e.cardPadding,
    dropdownEdgeChildVerticalPadding: e.paddingXXS,
    tabsActiveTextShadow: "0 0 0.25px currentcolor",
    tabsDropdownHeight: 200,
    tabsDropdownWidth: 120,
    tabsHorizontalItemMargin: `0 0 0 ${u(e.horizontalItemGutter)}`,
    tabsHorizontalItemMarginRTL: `0 0 0 ${u(e.horizontalItemGutter)}`
  });
  return [hn(t), $n(t), pn(t), gn(t), mn(t), Sn(t), bn(t)];
}, Cn), Zt = () => null;
process.env.NODE_ENV !== "production" && (Zt.displayName = "DeprecatedTabPane");
var _n = function(e, t) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, a = Object.getOwnPropertySymbols(e); r < a.length; r++)
    t.indexOf(a[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[r]) && (n[a[r]] = e[a[r]]);
  return n;
};
const st = (e) => {
  var t, n, a, r, i, l, o, s, d, h, f;
  const {
    type: y,
    className: w,
    rootClassName: R,
    size: C,
    onEdit: O,
    hideAdd: g,
    centered: b,
    addIcon: x,
    removeIcon: L,
    moreIcon: z,
    more: D,
    popupClassName: V,
    children: N,
    items: S,
    animated: I,
    style: $,
    indicatorSize: _,
    indicator: m,
    destroyInactiveTabPane: P,
    destroyOnHidden: U
  } = e, A = _n(e, ["type", "className", "rootClassName", "size", "onEdit", "hideAdd", "centered", "addIcon", "removeIcon", "moreIcon", "more", "popupClassName", "children", "items", "animated", "style", "indicatorSize", "indicator", "destroyInactiveTabPane", "destroyOnHidden"]), {
    prefixCls: K
  } = A, {
    direction: k,
    tabs: v,
    getPrefixCls: re,
    getPopupContainer: ne
  } = c.useContext(Ge), Z = re("tabs", K), E = Aa(Z), [W, Y, J] = xn(Z, E);
  let q;
  y === "editable-card" && (q = {
    onEdit: (T, {
      key: oe,
      event: me
    }) => {
      O == null || O(T === "add" ? me : oe, T);
    },
    removeIcon: (t = L ?? (v == null ? void 0 : v.removeIcon)) !== null && t !== void 0 ? t : /* @__PURE__ */ c.createElement(Da, null),
    addIcon: (x ?? (v == null ? void 0 : v.addIcon)) || /* @__PURE__ */ c.createElement(Ft, null),
    showAdd: g !== !0
  });
  const ie = re();
  if (process.env.NODE_ENV !== "production") {
    const T = ot("Tabs");
    process.env.NODE_ENV !== "production" && T(!("onPrevClick" in e) && !("onNextClick" in e), "breaking", "`onPrevClick` and `onNextClick` has been removed. Please use `onTabScroll` instead."), process.env.NODE_ENV !== "production" && T(!(_ || v != null && v.indicatorSize), "deprecated", "`indicatorSize` has been deprecated. Please use `indicator={{ size: ... }}` instead."), T.deprecated(!("destroyInactiveTabPane" in e || S != null && S.some((oe) => "destroyInactiveTabPane" in oe)), "destroyInactiveTabPane", "destroyOnHidden");
  }
  const ee = Xt(C), he = fn(S, N), ve = dn(Z, I), ye = Object.assign(Object.assign({}, v == null ? void 0 : v.style), $), $e = {
    align: (n = m == null ? void 0 : m.align) !== null && n !== void 0 ? n : (a = v == null ? void 0 : v.indicator) === null || a === void 0 ? void 0 : a.align,
    size: (o = (i = (r = m == null ? void 0 : m.size) !== null && r !== void 0 ? r : _) !== null && i !== void 0 ? i : (l = v == null ? void 0 : v.indicator) === null || l === void 0 ? void 0 : l.size) !== null && o !== void 0 ? o : v == null ? void 0 : v.indicatorSize
  };
  return W(/* @__PURE__ */ c.createElement(Qt, Object.assign({
    direction: k,
    getPopupContainer: ne
  }, A, {
    items: he,
    className: G({
      [`${Z}-${ee}`]: ee,
      [`${Z}-card`]: ["card", "editable-card"].includes(y),
      [`${Z}-editable-card`]: y === "editable-card",
      [`${Z}-centered`]: b
    }, v == null ? void 0 : v.className, w, R, Y, J, E),
    popupClassName: G(V, Y, J, E),
    style: ye,
    editable: q,
    more: Object.assign({
      icon: (f = (h = (d = (s = v == null ? void 0 : v.more) === null || s === void 0 ? void 0 : s.icon) !== null && d !== void 0 ? d : v == null ? void 0 : v.moreIcon) !== null && h !== void 0 ? h : z) !== null && f !== void 0 ? f : /* @__PURE__ */ c.createElement(Ca, null),
      transitionName: `${ie}-slide-up`
    }, D),
    prefixCls: Z,
    animated: ve,
    indicator: $e,
    // TODO: In the future, destroyInactiveTabPane in rc-tabs needs to be upgrade to destroyOnHidden
    destroyInactiveTabPane: U ?? P
  })));
};
st.TabPane = Zt;
process.env.NODE_ENV !== "production" && (st.displayName = "Tabs");
var Pn = function(e, t) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, a = Object.getOwnPropertySymbols(e); r < a.length; r++)
    t.indexOf(a[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[r]) && (n[a[r]] = e[a[r]]);
  return n;
};
const kt = (e) => {
  var {
    prefixCls: t,
    className: n,
    hoverable: a = !0
  } = e, r = Pn(e, ["prefixCls", "className", "hoverable"]);
  const {
    getPrefixCls: i
  } = c.useContext(Ge), l = i("card", t), o = G(`${l}-grid`, n, {
    [`${l}-grid-hoverable`]: a
  });
  return /* @__PURE__ */ c.createElement("div", Object.assign({}, r, {
    className: o
  }));
}, wn = (e) => {
  const {
    antCls: t,
    componentCls: n,
    headerHeight: a,
    headerPadding: r,
    tabsMarginBottom: i
  } = e;
  return Object.assign(Object.assign({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    minHeight: a,
    marginBottom: -1,
    padding: `0 ${u(r)}`,
    color: e.colorTextHeading,
    fontWeight: e.fontWeightStrong,
    fontSize: e.headerFontSize,
    background: e.headerBg,
    borderBottom: `${u(e.lineWidth)} ${e.lineType} ${e.colorBorderSecondary}`,
    borderRadius: `${u(e.borderRadiusLG)} ${u(e.borderRadiusLG)} 0 0`
  }, We()), {
    "&-wrapper": {
      width: "100%",
      display: "flex",
      alignItems: "center"
    },
    "&-title": Object.assign(Object.assign({
      display: "inline-block",
      flex: 1
    }, it), {
      [`
          > ${n}-typography,
          > ${n}-typography-edit-content
        `]: {
        insetInlineStart: 0,
        marginTop: 0,
        marginBottom: 0
      }
    }),
    [`${t}-tabs-top`]: {
      clear: "both",
      marginBottom: i,
      color: e.colorText,
      fontWeight: "normal",
      fontSize: e.fontSize,
      "&-bar": {
        borderBottom: `${u(e.lineWidth)} ${e.lineType} ${e.colorBorderSecondary}`
      }
    }
  });
}, En = (e) => {
  const {
    cardPaddingBase: t,
    colorBorderSecondary: n,
    cardShadow: a,
    lineWidth: r
  } = e;
  return {
    width: "33.33%",
    padding: t,
    border: 0,
    borderRadius: 0,
    boxShadow: `
      ${u(r)} 0 0 0 ${n},
      0 ${u(r)} 0 0 ${n},
      ${u(r)} ${u(r)} 0 0 ${n},
      ${u(r)} 0 0 0 ${n} inset,
      0 ${u(r)} 0 0 ${n} inset;
    `,
    transition: `all ${e.motionDurationMid}`,
    "&-hoverable:hover": {
      position: "relative",
      zIndex: 1,
      boxShadow: a
    }
  };
}, Tn = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    actionsLiMargin: a,
    cardActionsIconSize: r,
    colorBorderSecondary: i,
    actionsBg: l
  } = e;
  return Object.assign(Object.assign({
    margin: 0,
    padding: 0,
    listStyle: "none",
    background: l,
    borderTop: `${u(e.lineWidth)} ${e.lineType} ${i}`,
    display: "flex",
    borderRadius: `0 0 ${u(e.borderRadiusLG)} ${u(e.borderRadiusLG)}`
  }, We()), {
    "& > li": {
      margin: a,
      color: e.colorTextDescription,
      textAlign: "center",
      "> span": {
        position: "relative",
        display: "block",
        minWidth: e.calc(e.cardActionsIconSize).mul(2).equal(),
        fontSize: e.fontSize,
        lineHeight: e.lineHeight,
        cursor: "pointer",
        "&:hover": {
          color: e.colorPrimary,
          transition: `color ${e.motionDurationMid}`
        },
        [`a:not(${t}-btn), > ${n}`]: {
          display: "inline-block",
          width: "100%",
          color: e.colorIcon,
          lineHeight: u(e.fontHeight),
          transition: `color ${e.motionDurationMid}`,
          "&:hover": {
            color: e.colorPrimary
          }
        },
        [`> ${n}`]: {
          fontSize: r,
          lineHeight: u(e.calc(r).mul(e.lineHeight).equal())
        }
      },
      "&:not(:last-child)": {
        borderInlineEnd: `${u(e.lineWidth)} ${e.lineType} ${i}`
      }
    }
  });
}, On = (e) => Object.assign(Object.assign({
  margin: `${u(e.calc(e.marginXXS).mul(-1).equal())} 0`,
  display: "flex"
}, We()), {
  "&-avatar": {
    paddingInlineEnd: e.padding
  },
  "&-detail": {
    overflow: "hidden",
    flex: 1,
    "> div:not(:last-child)": {
      marginBottom: e.marginXS
    }
  },
  "&-title": Object.assign({
    color: e.colorTextHeading,
    fontWeight: e.fontWeightStrong,
    fontSize: e.fontSizeLG
  }, it),
  "&-description": {
    color: e.colorTextDescription
  }
}), Nn = (e) => {
  const {
    componentCls: t,
    colorFillAlter: n,
    headerPadding: a,
    bodyPadding: r
  } = e;
  return {
    [`${t}-head`]: {
      padding: `0 ${u(a)}`,
      background: n,
      "&-title": {
        fontSize: e.fontSize
      }
    },
    [`${t}-body`]: {
      padding: `${u(e.padding)} ${u(r)}`
    }
  };
}, In = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    overflow: "hidden",
    [`${t}-body`]: {
      userSelect: "none"
    }
  };
}, Rn = (e) => {
  const {
    componentCls: t,
    cardShadow: n,
    cardHeadPadding: a,
    colorBorderSecondary: r,
    boxShadowTertiary: i,
    bodyPadding: l,
    extraColor: o
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, rt(e)), {
      position: "relative",
      background: e.colorBgContainer,
      borderRadius: e.borderRadiusLG,
      [`&:not(${t}-bordered)`]: {
        boxShadow: i
      },
      [`${t}-head`]: wn(e),
      [`${t}-extra`]: {
        // https://stackoverflow.com/a/22429853/3040605
        marginInlineStart: "auto",
        color: o,
        fontWeight: "normal",
        fontSize: e.fontSize
      },
      [`${t}-body`]: Object.assign({
        padding: l,
        borderRadius: `0 0 ${u(e.borderRadiusLG)} ${u(e.borderRadiusLG)}`
      }, We()),
      [`${t}-grid`]: En(e),
      [`${t}-cover`]: {
        "> *": {
          display: "block",
          width: "100%",
          borderRadius: `${u(e.borderRadiusLG)} ${u(e.borderRadiusLG)} 0 0`
        }
      },
      [`${t}-actions`]: Tn(e),
      [`${t}-meta`]: On(e)
    }),
    [`${t}-bordered`]: {
      border: `${u(e.lineWidth)} ${e.lineType} ${r}`,
      [`${t}-cover`]: {
        marginTop: -1,
        marginInlineStart: -1,
        marginInlineEnd: -1
      }
    },
    [`${t}-hoverable`]: {
      cursor: "pointer",
      transition: `box-shadow ${e.motionDurationMid}, border-color ${e.motionDurationMid}`,
      "&:hover": {
        borderColor: "transparent",
        boxShadow: n
      }
    },
    [`${t}-contain-grid`]: {
      borderRadius: `${u(e.borderRadiusLG)} ${u(e.borderRadiusLG)} 0 0 `,
      [`${t}-body`]: {
        display: "flex",
        flexWrap: "wrap"
      },
      [`&:not(${t}-loading) ${t}-body`]: {
        marginBlockStart: e.calc(e.lineWidth).mul(-1).equal(),
        marginInlineStart: e.calc(e.lineWidth).mul(-1).equal(),
        padding: 0
      }
    },
    [`${t}-contain-tabs`]: {
      [`> div${t}-head`]: {
        minHeight: 0,
        [`${t}-head-title, ${t}-extra`]: {
          paddingTop: a
        }
      }
    },
    [`${t}-type-inner`]: Nn(e),
    [`${t}-loading`]: In(e),
    [`${t}-rtl`]: {
      direction: "rtl"
    }
  };
}, zn = (e) => {
  const {
    componentCls: t,
    bodyPaddingSM: n,
    headerPaddingSM: a,
    headerHeightSM: r,
    headerFontSizeSM: i
  } = e;
  return {
    [`${t}-small`]: {
      [`> ${t}-head`]: {
        minHeight: r,
        padding: `0 ${u(a)}`,
        fontSize: i,
        [`> ${t}-head-wrapper`]: {
          [`> ${t}-extra`]: {
            fontSize: e.fontSize
          }
        }
      },
      [`> ${t}-body`]: {
        padding: n
      }
    },
    [`${t}-small${t}-contain-tabs`]: {
      [`> ${t}-head`]: {
        [`${t}-head-title, ${t}-extra`]: {
          paddingTop: 0,
          display: "flex",
          alignItems: "center"
        }
      }
    }
  };
}, Ln = (e) => {
  var t, n;
  return {
    headerBg: "transparent",
    headerFontSize: e.fontSizeLG,
    headerFontSizeSM: e.fontSize,
    headerHeight: e.fontSizeLG * e.lineHeightLG + e.padding * 2,
    headerHeightSM: e.fontSize * e.lineHeight + e.paddingXS * 2,
    actionsBg: e.colorBgContainer,
    actionsLiMargin: `${e.paddingSM}px 0`,
    tabsMarginBottom: -e.padding - e.lineWidth,
    extraColor: e.colorText,
    bodyPaddingSM: 12,
    // Fixed padding.
    headerPaddingSM: 12,
    bodyPadding: (t = e.bodyPadding) !== null && t !== void 0 ? t : e.paddingLG,
    headerPadding: (n = e.headerPadding) !== null && n !== void 0 ? n : e.paddingLG
  };
}, Mn = Wt("Card", (e) => {
  const t = Vt(e, {
    cardShadow: e.boxShadowCard,
    cardHeadPadding: e.padding,
    cardPaddingBase: e.paddingLG,
    cardActionsIconSize: e.fontSize
  });
  return [
    // Style
    Rn(t),
    // Size
    zn(t)
  ];
}, Ln);
var jt = function(e, t) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, a = Object.getOwnPropertySymbols(e); r < a.length; r++)
    t.indexOf(a[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[r]) && (n[a[r]] = e[a[r]]);
  return n;
};
const Dn = (e) => {
  const {
    actionClasses: t,
    actions: n = [],
    actionStyle: a
  } = e;
  return /* @__PURE__ */ c.createElement("ul", {
    className: t,
    style: a
  }, n.map((r, i) => {
    const l = `action-${i}`;
    return /* @__PURE__ */ c.createElement("li", {
      style: {
        width: `${100 / n.length}%`
      },
      key: l
    }, /* @__PURE__ */ c.createElement("span", null, r));
  }));
}, Bn = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    prefixCls: n,
    className: a,
    rootClassName: r,
    style: i,
    extra: l,
    headStyle: o = {},
    bodyStyle: s = {},
    title: d,
    loading: h,
    bordered: f,
    variant: y,
    size: w,
    type: R,
    cover: C,
    actions: O,
    tabList: g,
    children: b,
    activeTabKey: x,
    defaultActiveTabKey: L,
    tabBarExtraContent: z,
    hoverable: D,
    tabProps: V = {},
    classNames: N,
    styles: S
  } = e, I = jt(e, ["prefixCls", "className", "rootClassName", "style", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "variant", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent", "hoverable", "tabProps", "classNames", "styles"]), {
    getPrefixCls: $,
    direction: _,
    card: m
  } = c.useContext(Ge), [P] = Wa("card", y, f);
  if (process.env.NODE_ENV !== "production") {
    const X = ot("Card");
    [["headStyle", "styles.header"], ["bodyStyle", "styles.body"], ["bordered", "variant"]].forEach(([B, de]) => {
      X.deprecated(!(B in e), B, de);
    });
  }
  const U = (X) => {
    var B;
    (B = e.onTabChange) === null || B === void 0 || B.call(e, X);
  }, A = (X) => {
    var B;
    return G((B = m == null ? void 0 : m.classNames) === null || B === void 0 ? void 0 : B[X], N == null ? void 0 : N[X]);
  }, K = (X) => {
    var B;
    return Object.assign(Object.assign({}, (B = m == null ? void 0 : m.styles) === null || B === void 0 ? void 0 : B[X]), S == null ? void 0 : S[X]);
  }, k = c.useMemo(() => {
    let X = !1;
    return c.Children.forEach(b, (B) => {
      (B == null ? void 0 : B.type) === kt && (X = !0);
    }), X;
  }, [b]), v = $("card", n), [re, ne, Z] = Mn(v), E = /* @__PURE__ */ c.createElement(Ma, {
    loading: !0,
    active: !0,
    paragraph: {
      rows: 4
    },
    title: !1
  }, b), W = x !== void 0, Y = Object.assign(Object.assign({}, V), {
    [W ? "activeKey" : "defaultActiveKey"]: W ? x : L,
    tabBarExtraContent: z
  });
  let J;
  const q = Xt(w), ie = !q || q === "default" ? "large" : q, ee = g ? /* @__PURE__ */ c.createElement(st, Object.assign({
    size: ie
  }, Y, {
    className: `${v}-head-tabs`,
    onChange: U,
    items: g.map((X) => {
      var {
        tab: B
      } = X, de = jt(X, ["tab"]);
      return Object.assign({
        label: B
      }, de);
    })
  })) : null;
  if (d || l || ee) {
    const X = G(`${v}-head`, A("header")), B = G(`${v}-head-title`, A("title")), de = G(`${v}-extra`, A("extra")), Oe = Object.assign(Object.assign({}, o), K("header"));
    J = /* @__PURE__ */ c.createElement("div", {
      className: X,
      style: Oe
    }, /* @__PURE__ */ c.createElement("div", {
      className: `${v}-head-wrapper`
    }, d && /* @__PURE__ */ c.createElement("div", {
      className: B,
      style: K("title")
    }, d), l && /* @__PURE__ */ c.createElement("div", {
      className: de,
      style: K("extra")
    }, l)), ee);
  }
  const he = G(`${v}-cover`, A("cover")), ve = C ? /* @__PURE__ */ c.createElement("div", {
    className: he,
    style: K("cover")
  }, C) : null, ye = G(`${v}-body`, A("body")), $e = Object.assign(Object.assign({}, s), K("body")), T = /* @__PURE__ */ c.createElement("div", {
    className: ye,
    style: $e
  }, h ? E : b), oe = G(`${v}-actions`, A("actions")), me = O != null && O.length ? /* @__PURE__ */ c.createElement(Dn, {
    actionClasses: oe,
    actionStyle: K("actions"),
    actions: O
  }) : null, ze = La(I, ["onTabChange"]), Xe = G(v, m == null ? void 0 : m.className, {
    [`${v}-loading`]: h,
    [`${v}-bordered`]: P !== "borderless",
    [`${v}-hoverable`]: D,
    [`${v}-contain-grid`]: k,
    [`${v}-contain-tabs`]: g == null ? void 0 : g.length,
    [`${v}-${q}`]: q,
    [`${v}-type-${R}`]: !!R,
    [`${v}-rtl`]: _ === "rtl"
  }, a, r, ne, Z), Fe = Object.assign(Object.assign({}, m == null ? void 0 : m.style), i);
  return re(/* @__PURE__ */ c.createElement("div", Object.assign({
    ref: t
  }, ze, {
    className: Xe,
    style: Fe
  }), J, ve, T, me));
});
var Hn = function(e, t) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, a = Object.getOwnPropertySymbols(e); r < a.length; r++)
    t.indexOf(a[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[r]) && (n[a[r]] = e[a[r]]);
  return n;
};
const jn = (e) => {
  const {
    prefixCls: t,
    className: n,
    avatar: a,
    title: r,
    description: i
  } = e, l = Hn(e, ["prefixCls", "className", "avatar", "title", "description"]), {
    getPrefixCls: o
  } = c.useContext(Ge), s = o("card", t), d = G(`${s}-meta`, n), h = a ? /* @__PURE__ */ c.createElement("div", {
    className: `${s}-meta-avatar`
  }, a) : null, f = r ? /* @__PURE__ */ c.createElement("div", {
    className: `${s}-meta-title`
  }, r) : null, y = i ? /* @__PURE__ */ c.createElement("div", {
    className: `${s}-meta-description`
  }, i) : null, w = f || y ? /* @__PURE__ */ c.createElement("div", {
    className: `${s}-meta-detail`
  }, f, y) : null;
  return /* @__PURE__ */ c.createElement("div", Object.assign({}, l, {
    className: d
  }), h, w);
}, Ke = Bn;
Ke.Grid = kt;
Ke.Meta = jn;
process.env.NODE_ENV !== "production" && (Ke.displayName = "Card");
const At = {
  sm: "16px",
  md: "24px",
  lg: "32px",
  none: "0px"
}, He = "md", An = Pa(Ke)`
  display: flex;
  flex-direction: column;
`, sr = ({
  outlined: e = !0,
  padding: t,
  actions: n,
  tabs: a,
  ...r
}) => {
  var s;
  const i = {
    header: He,
    body: He,
    ...ha(t) ? t : {
      header: t ?? He,
      body: t ?? He
    }
  }, l = ({ type: d, size: h, list: f, overflowMenu: y }) => {
    if (!(f != null && f.length)) return null;
    const w = y != null && y.after ? y.after : f.length, R = {
      icon: /* @__PURE__ */ Re(Ta, {}),
      size: h
    }, C = f.slice(0, w), O = () => {
      const g = f.slice(w).map(({ label: b, icon: x, disabled: L, onClick: z }, D) => {
        const V = `${D}-overflow-${b}`, { icon: N } = xa(x);
        return {
          key: V,
          label: b,
          disabled: L,
          icon: N,
          onClick: (S) => {
            z == null || z(S);
          }
        };
      });
      return /* @__PURE__ */ Re(
        _a,
        {
          placement: "bottomRight",
          trigger: ["click"],
          menu: {
            items: g
          },
          children: /* @__PURE__ */ Re(
            wt,
            {
              ...R,
              ...(y == null ? void 0 : y.buttonProps) || {}
            }
          )
        }
      );
    };
    return /* @__PURE__ */ pa("div", { className: "flex gap-2", children: [
      C == null ? void 0 : C.map(({ label: g, ...b }, x) => (x === C.length - 1 && (R.variant = b.variant, R.appearance = b.appearance, R.shape = b.shape), /* @__PURE__ */ Re(
        wt,
        {
          ...b,
          size: h,
          label: d == "icon" ? void 0 : g
        },
        x
      ))),
      C.length < f.length && O()
    ] });
  }, o = {
    ...r,
    variant: e ? "outlined" : "borderless",
    styles: {
      header: {
        ...!((s = a == null ? void 0 : a.list) != null && s.length) && {
          paddingInline: At[i.header]
        }
      },
      body: {
        overflow: "auto",
        padding: At[i.body]
      }
    },
    ...a && {
      tabList: a.list,
      activeTabKey: a.activeKey,
      onTabChange: a.onChange
    },
    extra: n ? l(n) : void 0
  };
  return /* @__PURE__ */ Re(An, { ...o });
};
export {
  sr as C
};
